var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReady(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Article-cr\\xE9ation-Ready",
    transform: "translate(-1196.000000, -24.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app-bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1060.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_thumb_up_black_24px-(1)",
    transform: "translate(133.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,20 L6.2,20 L6.2,10.4 L3,10.4 L3,20 L3,20 Z M20.6,11.2 C20.6,10.32 19.88,9.6 19,9.6 L13.952,9.6 L14.712,5.944 L14.736,5.688 C14.736,5.36 14.6,5.056 14.384,4.84 L13.536,4 L8.272,9.272 C7.976,9.56 7.8,9.96 7.8,10.4 L7.8,18.4 C7.8,19.28 8.52,20 9.4,20 L16.6,20 C17.264,20 17.832,19.6 18.072,19.024 L20.488,13.384 C20.56,13.2 20.6,13.008 20.6,12.8 L20.6,11.272 L20.592,11.264 L20.6,11.2 L20.6,11.2 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/ready.3daf3ee9.svg";
export { ForwardRef as ReactComponent };